import React from "react";
import { shorthands, tokens, useId, Input } from "@fluentui/react-components";
import styles from "./iconInput.module.scss";

const IconInput = (props) => {
  const { placeholder, handleChange, error, value, inputUnderlinewd, icon } =
    props;
  const underlineId = useId("input-underline");
  const handleChangeValue = (event) => {
    const value = event.target.value;
    handleChange(value);
  };

  return (
    <div className={styles.inputContainer}>
      <div className={styles.icon}>{icon}</div>
      <Input
        placeholder={placeholder}
        id={underlineId}
        onChange={handleChangeValue}
        value={value}
        className={styles.inputField}
      />
      {error && <p className="InputUnderline_errorMessage">{error}</p>}
    </div>
  );
};

export default IconInput;
